import { GetServerSideProps, GetServerSidePropsContext } from "next/types";
import { useState } from "react";

import {
  InsuranceGiLandingPageMainWrapper,
  InsuranceLanding,
  InsuranceLandingPageMainWrapper,
} from "@insurance/landing-ui/pages";
import { getAnalytics, setLandingPageAnalytics } from "@tm/insurance/analytics";
import { navigationActions } from "@tm/insurance/navigation";
import { PARTNER, PartnerType } from "@tm/isomorphic-utils";
import { getPartnerOnServerSide } from "@tm/server-utils";
import { DeviceContextV2Type, withDeviceProvider } from "@tm/ui-widgets";
import { PartnerContextProvider } from "@tm/ui-widgets/context";

import { getCookieByName } from "@tm/insurance/utils";
import { withReferrerProvider } from "@tm/ui-widgets/hoc";
import {
  withError,
  withGIInsuranceHeader,
  withMMTInsuranceHeader,
} from "@tm/ui/hoc";
import { getSeoLandingPageDetails } from "../../src/api";
import { withSeoHeadTags } from "../../src/hoc";
import { seoGSSP } from "../../src/utils/seoGSSP";

const analytics = getAnalytics();

export interface ILandingPageProps {
  data?: any;
  statusCode?: string;
  error?: any;
  device: DeviceContextV2Type;
  partner: PartnerType;
  referrer: string;
  experiment?: string;
  isMyBiz?: boolean;
}

export function LandingPage({
  data,
  device = "mobile",
  error,
  partner,
  referrer,
}: ILandingPageProps) {
  const headTags = data?.headTags || {};
  const [activeModal, setActiveModal] = useState("");
  setLandingPageAnalytics(data?.analytics?.pageLoad);
  const longImageUrl = data?.offers?.items?.[0]?.image_url;

  const goToMyOrders = () => {
    analytics?.trackLandingEvents(
      {
        actionType: "my_orders_clicked",
      }
      //'click'
    );

    const authCookie =
      getCookieByName("mmt-auth") || getCookieByName("OAUTH-GOIBIBO");

    if (authCookie) {
      navigationActions.navigateToOrderListing();
    } else {
      setActiveModal?.("LOGIN");
    }
  };
  // TODO: move header configurations to context
  const component =
    partner === PARTNER.GI
      ? withGIInsuranceHeader(
          <PartnerContextProvider partnerType={PARTNER.GI}>
            <InsuranceLanding setActiveModal={setActiveModal} data={data} />
          </PartnerContextProvider>,
          {
            Wrapper: InsuranceGiLandingPageMainWrapper,
            forceLogin: activeModal ? true : false,
          },
          "Secure International Travel",
          true,
          goToMyOrders,
          false,
          false
        )
      : withMMTInsuranceHeader(
          <PartnerContextProvider partnerType={PARTNER.MMT}>
            <InsuranceLanding setActiveModal={setActiveModal} data={data} />
          </PartnerContextProvider>,
          {
            type: "dualHeader",
            Wrapper: InsuranceLandingPageMainWrapper,
            activeModal: activeModal ? "LOGIN" : undefined,
            onModalChange: (modal) => setActiveModal(modal),
          },
          "Secure International Travel",
          true,
          goToMyOrders,
          false,
          false,
          false,
          false
        );

  return withError(
    withReferrerProvider(
      withDeviceProvider(
        withSeoHeadTags(component, headTags, partner, longImageUrl),
        device
      ),
      referrer
    ),
    error,
    "LANDING"
  );
}

export const getServerSideProps: GetServerSideProps = async (
  ctx: GetServerSidePropsContext
) => {
  const { req, query } = ctx;
  const { cmp = "" } = query || {};

  const partner = getPartnerOnServerSide(req?.headers);

  return seoGSSP(ctx, () => getSeoLandingPageDetails(partner), partner, cmp);
};

export default LandingPage;
